export const ADMIN_BRANCH_CREATE = '/emma/admin/branch/create'
export const ADMIN_BRANCH_LISTING = '/emma/admin/branch'
export const ADMIN_BRANCH_UPDATE = '/emma/admin/branch/:id'
export const ADMIN_EMPLOYEE_CREATE = '/emma/admin/employee/create'
export const ADMIN_EMPLOYEE_LISTING = '/emma/admin/employee'
export const ADMIN_EMPLOYEE_UPDATE = '/emma/admin/employee/:id'
export const ADMIN_MARKETING = '/emma/admin/marketing'
export const ADMIN_MARKETING_EDIT = '/emma/admin/marketing/edit'
export const ADMIN_PROBLEMS_LOCATIONS = '/emma/admin/problem-locations'
export const ADMIN_TRUCK_CREATE = '/emma/admin/truck/create'
export const ADMIN_TRUCK_LISTING = '/emma/admin/truck'
export const ADMIN_TRUCK_UPDATE = '/emma/admin/truck/:id'
export const ADMIN_CALENDAR_AVAILABILITIES = '/emma/admin/calendar-availabilities'
export const ADMIN_PRICING_RULES = '/emma/admin/pricing-rules'
export const ADMIN_PRICING_RULES_CREATE = '/emma/admin/pricing-rules/create'
export const CUSTOMER_AUTO_BOOKINGS = '/emma/auto-bookings'
export const CUSTOMER_CREATE = '/emma/customer/create'
export const CUSTOMER_LISTING = '/emma/customer'
export const CUSTOMER_ENHANCED_SALES = '/emma/enhanced-sales'
export const CUSTOMER_NEW_LEADS = '/emma/leads'
export const CUSTOMER_NEW_LEADS_TRIAGE = '/emma/leads/triage'
export const CUSTOMER_NEW_LEADS_TRIAGE_V2 = '/emma/leads/triage-v2'
export const CUSTOMER_NEW_LEADS_TRIAGE_V4 = '/emma/leads/triage-v4'
export const EMMA_LEADS = '/emma/emma-leads'
export const CUSTOMER_PAGE = '/emma/customer/:id'
export const DEBUG = '/emma/debug'
export const EMMA = '/emma'
export const HEALTH_CHECK = '/health-check'
export const MOVE_MANAGER = '/emma/move-manager'
export const MOVE_MANAGER_DAY = '/emma/move-manager/:pathDay?'
export const REPORTS_MANAGER = '/emma/report/manager'
export const REPORTS_MARKETING = '/emma/report/marketing'
export const REPORTS_MOVES = '/emma/report/moves'
export const REPORT_MOVER_GAMES = '/emma/report/mover-games'
export const ROOT = '/'
export const SECURED = '/secured'
export const SIGN_IN = '/sign-in'
export const UNHANDLED = '*'

export enum EmmaPath {
  DEBUG = '/emma/debug',
  EMMA = '/emma',
  ROOT = '/',
  SECURED = '/secured',
  SIGN_IN = '/sign-in',
  UNHANDLED = '*',

  // existing paths below
  CUSTOMER_LISTING = '/emma/customer',
  CUSTOMER_NEW_LEADS = '/emma/leads',
  CUSTOMER_NEW_LEADS_TRIAGE = '/emma/leads/triage',
  CUSTOMER_NEW_LEADS_TRIAGE_V2 = '/emma/leads/triage-v2',
  CUSTOMER_NEW_LEADS_TRIAGE_V4 = '/emma/leads/triage-v4',
  CUSTOMER_AUTO_BOOKINGS = '/emma/auto-bookings',
  CUSTOMER_ENHANCED_SALES = '/emma/enhanced-sales',
  CUSTOMER_CREATE = '/emma/customer/create',
  CUSTOMER_PAGE = '/emma/customer/:id',
  ADMIN_BRANCH_LISTING = '/emma/admin/branch',
  ADMIN_TRIP_TRACKER_LISTING = '/emma/admin/trip-tracker',
  ADMIN_TRUCK_LISTING = '/emma/admin/truck',
  ADMIN_NPS_LISTING = '/emma/admin/nps',
  ADMIN_EMPLOYEE_LISTING = '/emma/admin/employee',
  ADMIN_RIPPLING_WORK_HOURS_LISTING = '/emma/admin/rippling-work-hours',
  ADMIN_MARKETING = '/emma/admin/marketing',
  ADMIN_PROBLEMS_LOCATIONS = '/emma/admin/problem-locations',
  ADMIN_MOVE_REPORTS = '/emma/admin/move-reports',
  ADMIN_BRANCH_CREATE = '/emma/admin/branch/create',
  ADMIN_BRANCH_UPDATE = '/emma/admin/branch/:id',
  ADMIN_TRUCK_UPDATE = '/emma/admin/truck/:id',
  ADMIN_TRUCK_CREATE = '/emma/admin/truck/create',
  ADMIN_EMPLOYEE_UPDATE = '/emma/admin/employee/:id',
  ADMIN_EMPLOYEE_CREATE = '/emma/admin/employee/create',
  ADMIN_MARKETING_EDIT = '/emma/admin/marketing/edit',
  ADMIN_CALENDAR_AVAILABILITIES = '/emma/admin/calendar-availabilities',
  ADMIN_PRICING_RULES = '/emma/admin/pricing-rules',
  ADMIN_PRICING_RULES_CREATE = '/emma/admin/pricing-rules/create',
  ADMIN_NOTIFICATION_RULES = '/emma/admin/notification-rules',
  ADMIN_ZIP_ZONES = '/emma/admin/zip-zones',
  ADMIN_SERVICE_ZONES = '/emma/admin/service-zones',
  ADMIN_MAP = '/emma/admin/map',
  ADMIN_CRON_JOBS = '/emma/admin/cron-jobs',
  ADMIN_MOVES_MAP = '/emma/admin/moves-map',
  ADMIN_BOOKING_SIMULATOR = '/emma/admin/booking-simulator',
  ADMIN_ESTIMATION_SIMULATOR = '/emma/admin/estimation-simulator',
  ADMIN_REASSIGNMENT_FORM = '/emma/tools/reassignment-form',
  ADMIN_RELOCATION_TREND_MAP = '/emma/admin/relocation-trend-map',
  ADMIN_DOCS = '/emma/admin/docs/:type/:page?',
  ADMIN_EMAIL_TEMPLATES = '/emma/admin/email-templates',
  ADMIN_EMAIL_TEMPLATES_CREATE = '/emma/admin/email-templates/create',
  ADMIN_EMAIL_TEMPLATES_UPDATE = '/emma/admin/email-templates/:id',
  ADMIN_TRACKING_INCORRECT_MOVES = '/emma/admin/tracking-incorrect-moves',

  REPORT_KPIS = '/emma/report/kpis',
  REPORT_DIALPAD_STATS = '/emma/report/dialpad-stats',
  REPORT_BRANCH_KPIS = '/emma/report/branch-kpis',
  REPORT_NPS = '/emma/report/nps',
  REPORT_DAMAGES = '/emma/report/damages',
  REPORT_REVIEWS = '/emma/report/reviews',
  REPORT_GENERAL = '/emma/report/general',
  REPORT_TUR = '/emma/report/tur',
  REPORT_SALES = '/emma/report/sales',
  REPORT_SALES_PIPELINE = '/emma/report/sales-pipeline',
  REPORT_REVENUE = '/emma/report/revenue',
  REPORT_ATTENDANCE_POINTS = '/emma/report/attendance-points',
  REPORT_OVER_TIME = '/emma/report/over-time',
  REPORT_REVENUE_DETAILS = '/emma/report/revenue/details',
  REPORT_SALES_DETAILS = '/emma/report/sales/details',
  REPORT_SETTINGS = '/emma/report/settings',
  REPORT_BILLABLE_EFFICIENCY = '/emma/report/billable-efficiency',
  REPORT_CONTRACT_EFFICIENCY = '/emma/report/contract-efficiency',
  REPORT_EINSTEIN_GAMES = '/emma/report/einstein-games',
  REPORT_EINSTEIN_GAMES_RULES = '/emma/report/einstein-games/rules',
  REPORT_MOVER_GAMES = '/emma/report/einstein-games/details',
  REPORT_DRIVER_SCORE = '/emma/report/driver-score',
  REPORT_PRAISE = '/emma/report/praise',
  ADMIN_LEADFERNO_CONVERSION = '/emma/admin/leadferno-conversion',
  REPORT_MARKETING_DASHBOARD = '/emma/report/marketing-dashboard',
  REPORT_SNAPSHOT = '/emma/report/snapshot',
  REPORTS_MOVES = '/emma/report/moves',
  REPORTS_MANAGER = '/emma/report/manager',
  REPORTS_MARKETING = '/emma/report/marketing',
  ACCOUNT_MY_SCHEDULE = '/emma/account/my-schedule',
  MOVE_MANAGER = '/emma/move-manager',
  MOVE_MANAGER_DAY = '/emma/move-manager/:pathDay?',
  MOVER_MOVES = '/emma/mover-moves',
  SALES_MANAGER_REVIEW = '/emma/sales-manager-review',
  SALES_MANAGER_REVIEW_HISTORY = '/emma/sales-manager-review/history',
  EMMA_LEADS = '/emma/emma-leads',
  HEALTH_CHECK = '/health-check',
  ADMIN_PERFORMANCE_LOG = '/emma/admin/performance-log',
  ADMIN_ATTENDANCE_APPROVALS = '/emma/admin/attendance-approvals',
  ECP_QUICK_PRAISE_REDIRECTS = '/emma/ecp-praise-redirects',
}
